import { render } from "./HealthCheck.vue?vue&type=template&id=10e6106e"
import script from "./HealthCheck.vue?vue&type=script&lang=js"
export * from "./HealthCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__